import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {take} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return new Promise<boolean>((resolve, reject) => {

            this.authService.getAuth().pipe(take(1)).subscribe(authUser => {
                let canActivate = true;
                if (authUser.isLogIn) {
                  const roles = route.data.roles;
                  if (roles && roles.length > 0) {
                    // Check role

                  } else {
                    canActivate = true;
                  }
                } else {
                  canActivate = false;
                }
                if (!canActivate) {
                  this.router.navigate(['/login']);
                }
                resolve(canActivate);
            });
        });

    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(childRoute, state);
    }
}
